import {FC} from 'react'
import {ClientInfo} from '../../core/_models'
import {useParams} from 'react-router-dom'
import {KTSVG} from '../../../../template/helpers'
import {appsAPI} from '../../../../services/AppsService'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

type Props = {
  data: string
  clientInfo?: ClientInfo
}

const ModalClient: FC<Props> = ({data, clientInfo}) => {
  const {appId} = useParams()
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)
  // client names from CRM are shown only with personal data and client names in CDR enabled (docs/PERSONAL_DATA.md)
  const showClient = clientInfo != null && app?.personal_data === true && app?.cdr_client_names === true

  return (
    <>
      <div className='d-flex justify-content-between align-items-center'>
        <div className='text-muted small mb-1'>Звонок кому</div>
        {showClient && (
          <a
            href={`https://${app?.crm_domain}/crm/${clientInfo?.type.toLowerCase()}/details/${clientInfo?.id}/`}
            className='ms-2'
            target='_blank'
            rel='noreferrer'
          >
            <KTSVG
              path='/media/icons/duotune/arrows/arr095.svg'
              className='svg-icon svg-icon-gray-900 text-hover-primary'
            />
          </a>
        )}
      </div>
      <div className='fw-semibold'>
        <div className='d-flex align-items-center'>
          <div className='d-flex justify-content-start flex-column me-3 text-gray-800'>
            <span>
              {showClient ? (
                <>
                  <OverlayTrigger
                    delay={{show: 50, hide: 50}}
                    overlay={
                      <Tooltip id='tooltip-title' style={{position: 'fixed'}}>
                        {data}
                      </Tooltip>
                    }
                  >
                    <span>{clientInfo?.name}</span>
                  </OverlayTrigger>
                  <div className='fs-7 text-gray-700'>{clientInfo?.company?.title}</div>
                </>
              ) : (
                <span className=''>{data}</span>
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  )
}

export {ModalClient}
